import { Card, CardContent } from '@/components/ui/card';
import { DollarSign, Clock, Star } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const RoiSection = () => {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gradient-to-r from-primary/5 via-background to-secondary/5">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-4 text-center">
          {t('landing.roiSection.title')}
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          {t('landing.roiSection.subtitle')}
        </p>

        <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <Card className="text-center hover:shadow-lg transition-shadow">
            <CardContent className="pt-6">
              <div className="flex items-center justify-center w-16 h-16 rounded-full bg-destructive/10 mx-auto mb-4">
                <Clock className="w-8 h-8 text-destructive" />
              </div>
              <h3 className="text-2xl font-bold mb-2">{t('landing.roiSection.timeWasted')}</h3>
              <p className="text-sm text-muted-foreground">
                {t('landing.roiSection.timeWastedText')}
              </p>
            </CardContent>
          </Card>

          <Card className="text-center hover:shadow-lg transition-shadow">
            <CardContent className="pt-6">
              <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mx-auto mb-4">
                <DollarSign className="w-8 h-8 text-primary" />
              </div>
              <h3 className="text-2xl font-bold mb-2">{t('landing.roiSection.costOfReview')}</h3>
              <p className="text-sm text-muted-foreground">
                {t('landing.roiSection.costOfReviewText')}
              </p>
            </CardContent>
          </Card>

          <Card className="text-center hover:shadow-lg transition-shadow border-primary">
            <CardContent className="pt-6">
              <div className="flex items-center justify-center w-16 h-16 rounded-full bg-primary/10 mx-auto mb-4">
                <Star className="w-8 h-8 text-primary" />
              </div>
              <h3 className="text-2xl font-bold mb-2 text-primary">{t('landing.roiSection.zeroStress')}</h3>
              <p className="text-sm text-muted-foreground">
                {t('landing.roiSection.zeroStressText')}
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="text-center mt-8">
          <p className="text-lg font-semibold" dangerouslySetInnerHTML={{ __html: t('landing.roiSection.calculation') }} />
          <p className="text-sm text-muted-foreground mt-2">
            {t('landing.roiSection.monthlyLoss')}
          </p>
        </div>
      </div>
    </section>
  );
};
